import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Boat Trips from Faro · Private Yacht · Morningstar";
const DESC =
  "Private boat trips from Faro aboard Morningstar — sailing from Marina de Vilamoura with easy transfer from Faro Airport. Ria Formosa, Benagil cave and sunset cruises, up to 18 guests.";
const PATH = "/boat-trips-faro";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/boat-trips-faro")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Boat Trips from Faro · Algarve",
        title: "Boat trips from Faro aboard ",
        titleAccent: "Morningstar.",
        sub: "Direct transfer from Faro Airport to Marina de Vilamoura — Ria Formosa, Tavira islands, Benagil cave tours and sunset cruises along the Algarve coast.",
        ctaPrimary: "View cruises",
        ctaSecondary: "Plan my day",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "boat trips Faro, Faro boat hire, Faro yacht charter, Ria Formosa boat tour, Algarve cruise from Faro",
      altPath: { en: PATH, pt: "/pt/passeios-de-barco-faro" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private boat trips from Faro",
              description: DESC,
              url: URL,
              itinerary: "Marina de Vilamoura → Ria Formosa / Algarve coast → swim stop → return.",
              durationHours: 5,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Boat Trips from Faro", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("en")) },
      ],
    }),
});